import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
	standalone: true,
	imports: [CommonModule],
	selector: 'cpi-ring-loading-effect',
	templateUrl: './ring-loading-effect.component.html',
	styleUrl: './ring-loading-effect.component.scss',
})
export class RingLoadingEffectComponent {
	@Input()
	color = 'var(--white-2)';

	@Input()
	size = '25px';

	@Input()
	thickness = '2px';
}
